import { MediaHelpers } from '@tldraw/tldraw'

export const getImageSizeFromSrc = (src: string) => MediaHelpers.getImageSizeFromSrc(src)
